export default __webpack_public_path__ + "static/media/bg.5215dfa3.png";